module.exports = __webpack_public_path__ + "static/media/answerTop@2x.e17c3d1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerTop@2x.png
// module id = 1728
// module chunks = 0 1